import { get } from 'lodash';

const extractRecommendedSearchTerms = ({ prismicSearchTerms }) =>
  get(prismicSearchTerms, 'data.recommended_search_terms', '').split(',');

export default prismicData => ({
  recommendedSearchTerms: extractRecommendedSearchTerms(prismicData)
});
